export const EXPIRED = 'expired';
export const TODAY = 'today';
export const TOMORROW = 'tomorrow';
export const UPCOMING = 'upcoming';
